import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { CSS_PROPERTIES } from '../constants';

/* eslint-disable react/jsx-props-no-spreading */
const useHeightTransitions = (View) => {
  const HeightTransitions = ({ bufferHeight, ...props }) => {
    const ref = useRef(null);
    const [height, setHeight] = useState(CSS_PROPERTIES.AUTO);

    useEffect(() => {
      const resizeObserver = new ResizeObserver(() => {
        const { clientHeight = 0 } = ref && ref.current ? ref.current : {};
        // Buffer height is to avoid added height styles by ref
        setHeight(clientHeight + bufferHeight);
      });

      resizeObserver.observe(ref.current);

      return () => resizeObserver.disconnect();
    }, []);

    return (
      <View contentRef={ref} height={height} {...props} />
    );
  };

  HeightTransitions.propTypes = {
    bufferHeight: PropTypes.number,
    showHeightTransitions: PropTypes.bool,
  };

  HeightTransitions.defaultProps = {
    bufferHeight: 0,
    showHeightTransitions: false,
  };

  return HeightTransitions;
};

export default useHeightTransitions;
